import type { MovieListItem } from '../api/library';
import { MediaCard } from './MediaCard';

interface Props {
  items: MovieListItem[];
}

export function LibraryGrid({ items }: Props) {
  if (items.length === 0) {
    return (
      <div className="rounded-2xl border border-surface-divider bg-surface p-10 text-center text-text-secondary">
        Nothing here yet. Try uploading a movie.
      </div>
    );
  }
  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
      {items.map((m) => (
        <MediaCard key={m.id} item={m} />
      ))}
    </div>
  );
}
